import { Component, Output, EventEmitter } from "@angular/core";

@Component({
    selector: "cell-edit-overlay",
    templateUrl: "./cellEditOverlay.tmpl.html",
    standalone: false
})
export class CellEditOverlay
{

    @Output()
    doLeaveCellEdit = new EventEmitter<boolean>();

    leaveCellEdit(cancel: boolean): void
    {
        this.doLeaveCellEdit.emit(cancel);
    }
}
